import PropTypes from 'prop-types';

import { DownloadIcon, OverlayPopover } from '@utilities';

import DownloadPowerPoint from './components/DownloadPowerPoint';
import DownloadXLSX from './components/DownloadXLSX';

const Download = ({
  customFileName,
  downloadData,
  downloadFileUrl,
  downloadLabel,
  isDownloadDropdownActive,
  isExportingAllTabs,
  onExportAllTabs,
  onExportCurrentTab,
  setIsDownloadDropdownActive,
  showCurrentTabPowerPoint = true,
  target,
}) => {
  if (!downloadData && !onExportAllTabs) {
    return null;
  }

  return (
    <OverlayPopover
      header="Download Options"
      isActive={isDownloadDropdownActive}
      onHide={() => setIsDownloadDropdownActive(false)}
      target={target}
    >
      <ul data-testid="download-options-popover">
        <li>
          <DownloadXLSX downloadFileUrl={downloadFileUrl} downloadLabel={downloadLabel} />
        </li>
        {showCurrentTabPowerPoint && downloadData && (
          <li>
            <DownloadPowerPoint
              customFileName={customFileName}
              data={downloadData}
              downloadLabel={downloadLabel}
              onDownload={onExportCurrentTab}
            />
          </li>
        )}
        {onExportAllTabs && (
          <li>
            <button
              aria-label="Download entire report PowerPoint"
              data-testid="download-powerpoint-all-tabs-button"
              disabled={isExportingAllTabs}
              onClick={onExportAllTabs}
            >
              <DownloadIcon />
              <span>
                {isExportingAllTabs ? '.PPT File - Preparing…' : '.PPT File - Entire Report'}
              </span>
            </button>
          </li>
        )}
      </ul>
    </OverlayPopover>
  );
};

Download.propTypes = {
  customFileName: PropTypes.string,
  downloadData: PropTypes.object,
  downloadFileUrl: PropTypes.string,
  downloadLabel: PropTypes.string,
  isDownloadDropdownActive: PropTypes.bool,
  isExportingAllTabs: PropTypes.bool,
  onExportAllTabs: PropTypes.func,
  onExportCurrentTab: PropTypes.func,
  setIsDownloadDropdownActive: PropTypes.func,
  showCurrentTabPowerPoint: PropTypes.bool,
  target: PropTypes.object,
};

export default Download;
